import React from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import UseGeneral from "../../hooks/useGeneral";
import Product from "../product";
import "./style.css";
const RelatedProducts = ({ products, getData }) => {
  const { language } = UseGeneral();

  return (
    <div className="relatedProductsSlider">
      <h3
        style={{
          textAlign: "center",
          fontSize: "35px",
          fontWeight: 700,
          margin: "auto",
          marginTop: "56px",
        }}
      >
        {language == "ar" ? "ربما يعجبك أيضا" : "You may also like"}
      </h3>
      <div
        className="rowDiv row_prods bannerDiv"
        style={{ marginBottom: "65px", rowGap: "14px" }}
      >
        {/* <CategoriesProductsSlider
          getData={getData}
          productsData={products}
          language={language}
        /> */}
        {products &&
          products.length > 0 &&
          products.map((item) => {
            return (
              <Product
                homestyle={true}
                getData={getData}
                item={item}
                id={item?.id}
                image={
                  item?.images &&
                  item?.images.length > 0 &&
                  item?.images[0]?.url
                }
                title={language == "ar" ? item?.title_ar : item.title_en}
                price={item?.price}
                discount={item?.discount}
                discountRatio={item?.discount_ratio}
              />
            );
          })}
      </div>
    </div>
  );
};

export default RelatedProducts;
